import i18next from 'i18next';
import {bounceMessage} from '../../../layout/userMessages/UserMessage';
import {isAiAgentSupportedFile} from './fileToDataUrl';

export const ACCEPTED_FILE_TYPES =
    'image/jpeg,image/jpg,image/png,image/webp,image/gif,image/heic,image/heif,.heic,.heif,application/pdf';

export const warnUnsupportedFile = () =>
    bounceMessage(i18next.t('fileUnsupported', {ns: 'aiAgent'}), 'warning');

export const warnFileTooLarge = () =>
    bounceMessage(i18next.t('fileTooLarge', {ns: 'aiAgent'}), 'warning');

/**
 * `rejected` separates "a file was offered and we cannot read it" from "no file here at
 * all" — pasting plain text must stay silent, pasting a Word file must not.
 * Serves both paste (clipboardData) and drop (dataTransfer) — same DataTransfer shape.
 */
export type TransferFileResult = {file: File | null; rejected: boolean};

export function getTransferSupportedFile(transferData: DataTransfer | null): TransferFileResult {
    if(!transferData) {
        return {file: null, rejected: false};
    }

    const files = Array.from(transferData.files ?? []);
    const itemFiles = Array.from(transferData.items ?? [])
        .filter(item => item.kind === 'file')
        .map(item => item.getAsFile())
        .filter((file): file is File => !!file);

    const supported = [...files, ...itemFiles].find(isAiAgentSupportedFile);
    if(supported) {
        return {file: supported, rejected: false};
    }

    return {file: null, rejected: !!files.length || !!itemFiles.length};
}
